import { useAuth } from "../../../components/contexts/AuthContext"

/** Mitarbeiter-Login ohne verknüpften Mitarbeiter-Datensatz (Backend 403 "Unkown user"): nur Abmelden möglich, kein erneutes Login-Routing. */
export default function AccountIncomplete() {
    const auth = useAuth()
    return (
        <main className="flex items-center justify-center w-screen min-h-screen bg-base-100 p-4">
            <div className="w-full max-w-md bg-white rounded-default shadow-lg p-8 flex flex-col gap-6 text-center">
                <h1 className="text-2xl font-semibold">Konto nicht vollständig eingerichtet</h1>
                <p>
                    Ihr Benutzerkonto{auth.session?.user.email ? ` (${auth.session.user.email})` : ""} ist noch keinem Mitarbeiter zugeordnet. Bitte wenden Sie sich an Ihre Verwaltung.
                </p>
                <button type="button" className="btn btn-primary w-full" onClick={() => void auth.logout()}>
                    Abmelden
                </button>
            </div>
        </main>
    )
}
